import styled from '@emotion/styled'
import { getThemeSpacing } from '../styles/appTheme'

export const GridContainer = styled('div')({
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    gridGap: getThemeSpacing(1),
    width: '100%',
})

export const GridColumn = styled('div')({
    // padding: getThemeSpacing(1),
})

/**
 * Replaces the MUI <Container xs />
 */
export const StyledContainerMaxWidth = styled('div')`
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    box-sizing: border-box;
    margin-right: auto;
    display: block;
`
